var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel-body", attrs: { id: "shipping-multichannel" } },
    [
      _c("p", { staticClass: "text-size-20" }, [
        _vm._v("STOCKCREW倉庫の商品に対し出荷依頼を作成することができます ")
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "mr-t-15" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-warning check-maintenance",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                $event.preventDefault()
                _vm.openModalUpload()
              }
            }
          },
          [_vm._v("CSVアップロード")]
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c(
          "div",
          { staticClass: "mr-t-20", staticStyle: { "min-width": "1500px" } },
          [
            _c("div", { staticClass: "flexbox gap-15" }, [
              _c("svg", { attrs: { width: "50", height: "50" } }, [
                _c("circle", {
                  attrs: {
                    cx: "25",
                    cy: "25",
                    r: "20",
                    stroke: "#008cc6",
                    "stroke-width": "3",
                    fill: "#008cc6"
                  }
                }),
                _vm._v(" "),
                _c(
                  "text",
                  {
                    attrs: {
                      x: "50%",
                      y: "50%",
                      "text-anchor": "middle",
                      "dominant-baseline": "central",
                      "font-size": "20",
                      fill: "#fff"
                    }
                  },
                  [_vm._v("1")]
                )
              ]),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "font-bold text-size-16 text-primary" },
                [_vm._v("基本情報入力")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "mr-t-10 bg-white mr-l-30",
                staticStyle: {
                  border: "1px solid #ccc",
                  "margin-left": "30px",
                  padding: "10px"
                }
              },
              [
                _c("div", { staticClass: "box-delivery-name m-b-md" }, [
                  _c("div", { staticClass: "row" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-10 col-lg-7" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.shippingName,
                            expression: "shippingName",
                            modifiers: { trim: true }
                          }
                        ],
                        class: [
                          "form-control",
                          _vm.shippingName ? "" : "bg-no-input"
                        ],
                        attrs: { type: "text" },
                        domProps: { value: _vm.shippingName },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.shippingName = $event.target.value.trim()
                          },
                          blur: function($event) {
                            _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "※セールモンスターのみが使用する項目です。セラー様が管理しやすい名称をご入力ください。"
                        )
                      ]),
                      _vm._v(" "),
                      _vm.validateErrors.shippingName
                        ? _c("div", { staticClass: "text-red" }, [
                            _c("b", [
                              _vm._v(_vm._s(_vm.validateErrors.shippingName))
                            ])
                          ])
                        : _vm._e()
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "m-b-md" }, [
                  _c("div", { staticClass: "row" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-10 col-lg-7" }, [
                      _c("div", { staticClass: "flexbox gap-10" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.requestNo,
                              expression: "requestNo",
                              modifiers: { trim: true }
                            }
                          ],
                          staticClass: "form-control w-500",
                          class: [_vm.validateRequestNo() ? "" : "bg-no-input"],
                          attrs: { type: "text" },
                          domProps: { value: _vm.requestNo },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.requestNo = $event.target.value.trim()
                            },
                            blur: function($event) {
                              _vm.$forceUpdate()
                            }
                          }
                        }),
                        _vm._v(
                          "\n                半角英数字、ハイフンのみ入力可\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "※ショップの注文番号等をご入力ください。 送り状ラベルに表示されます。"
                        )
                      ]),
                      _vm._v(" "),
                      _vm.validateErrors.requestNo
                        ? _c("div", { staticClass: "text-red" }, [
                            _c("b", [
                              _vm._v(_vm._s(_vm.validateErrors.requestNo))
                            ])
                          ])
                        : _vm._e()
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "box-origin-info-default m-b-sm" }, [
                  _c("div", { staticClass: "row" }, [
                    _vm._m(3),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-9 col-lg-10" }, [
                      _vm.shippingInfo
                        ? _c("div", { staticClass: "delivery-info-default" }, [
                            _c("div", [_vm._v(_vm._s(_vm.shippingInfo.name))]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.shippingInfo.postalCode) +
                                  "    " +
                                  _vm._s(_vm.shippingInfo.prefecture) +
                                  " " +
                                  _vm._s(_vm.shippingInfo.address1) +
                                  " " +
                                  _vm._s(_vm.shippingInfo.address2) +
                                  "\n                "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(_vm._s(_vm.shippingInfo.phoneNo))
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "text--underline",
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              _vm.openModalShippingMultichannelInfo()
                            }
                          }
                        },
                        [_vm._v("登録・変更はこちら")]
                      ),
                      _vm._v(" "),
                      _vm.validateErrors.shippingInfo
                        ? _c("div", { staticClass: "text-red" }, [
                            _c("b", [
                              _vm._v(_vm._s(_vm.validateErrors.shippingInfo))
                            ])
                          ])
                        : _vm._e()
                    ])
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mr-t-20", staticStyle: { "min-width": "1500px" } },
          [
            _c("div", { staticClass: "flexbox gap-15" }, [
              _c("svg", { attrs: { width: "50", height: "50" } }, [
                _c("circle", {
                  attrs: {
                    cx: "25",
                    cy: "25",
                    r: "20",
                    stroke: "#008cc6",
                    "stroke-width": "3",
                    fill: "#008cc6"
                  }
                }),
                _vm._v(" "),
                _c(
                  "text",
                  {
                    attrs: {
                      x: "50%",
                      y: "50%",
                      "text-anchor": "middle",
                      "dominant-baseline": "central",
                      "font-size": "20",
                      fill: "#fff"
                    }
                  },
                  [_vm._v("2")]
                )
              ]),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "font-bold text-size-16 text-primary" },
                [_vm._v("お届け先情報入力")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "mr-t-10 bg-white mr-l-30",
                staticStyle: {
                  border: "1px solid #ccc",
                  "margin-left": "30px",
                  padding: "10px",
                  height: "150px"
                }
              },
              [
                _vm.deliveryInfo
                  ? _c("div", { staticClass: "m-b-sm" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "pd-l-15 pd-r-15" }, [
                          _c("b", { staticClass: "w-130" }, [
                            _vm._v("お届け先名：")
                          ]),
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.deliveryInfo.name) +
                              "\n            "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "pd-l-15 pd-r-15" }, [
                          _c("b", { staticClass: "w-130" }, [
                            _vm._v("郵便番号：")
                          ]),
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.deliveryInfo.postalCode) +
                              "\n              "
                          ),
                          _c("b", { staticClass: "w-130 pd-l-30" }, [
                            _vm._v("住所：")
                          ]),
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.deliveryInfo.prefecture) +
                              " " +
                              _vm._s(_vm.deliveryInfo.address1) +
                              " " +
                              _vm._s(_vm.deliveryInfo.address2) +
                              "\n            "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "pd-l-15 pd-r-15" }, [
                          _c("b", { staticClass: "w-130" }, [
                            _vm._v("電話番号：")
                          ]),
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.deliveryInfo.phoneNo) +
                              "\n            "
                          )
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.validateErrors.deliveryInfo
                  ? _c("div", { staticClass: "text-red" }, [
                      _c("b", [_vm._v(_vm._s(_vm.validateErrors.deliveryInfo))])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary check-maintenance",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        _vm.openModalRegisterDeliveryInfo()
                      }
                    }
                  },
                  [_vm._v("お届け先情報を入力")]
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mr-t-20", staticStyle: { "min-width": "1500px" } },
          [
            _c("div", { staticClass: "flexbox gap-15" }, [
              _c("svg", { attrs: { width: "50", height: "50" } }, [
                _c("circle", {
                  attrs: {
                    cx: "25",
                    cy: "25",
                    r: "20",
                    stroke: "#008cc6",
                    "stroke-width": "3",
                    fill: "#008cc6"
                  }
                }),
                _vm._v(" "),
                _c(
                  "text",
                  {
                    attrs: {
                      x: "50%",
                      y: "50%",
                      "text-anchor": "middle",
                      "dominant-baseline": "central",
                      "font-size": "20",
                      fill: "#fff"
                    }
                  },
                  [_vm._v("3")]
                )
              ]),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "font-bold text-size-16 text-primary" },
                [_vm._v("商品情報入力")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "mr-t-10 bg-white mr-l-30",
                staticStyle: {
                  border: "1px solid #ccc",
                  "margin-left": "30px",
                  padding: "10px"
                },
                attrs: { id: "product-input" }
              },
              [
                _c("fixed-header", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isShowFixedHeader,
                      expression: "isShowFixedHeader"
                    }
                  ],
                  attrs: { textBtnRegister: "出荷依頼" },
                  on: {
                    handleClickAdd: function($event) {
                      _vm.openModalProductAdd()
                    },
                    handleClickRegister: function($event) {
                      _vm.submitValidate()
                    }
                  }
                }),
                _vm._v(" "),
                _c("p", {}, [
                  _vm._v("出荷する商品を選択し、商品情報を入力してください。")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flexbox justify-between" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary check-maintenance",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.openModalProductAdd()
                        }
                      }
                    },
                    [_vm._v("商品選択")]
                  ),
                  _vm._v(" "),
                  _vm.selectedProducts.length
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-primary check-maintenance",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              _vm.handleGetStorageSize()
                            }
                          }
                        },
                        [_vm._v("保管サイズを再取得")]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.selectedProducts.length
                  ? _c("div", { staticClass: "table-selected-products" }, [
                      _c("table", { staticClass: "full-width" }, [
                        _vm._m(4),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.selectedProducts, function(
                            selectedProduct,
                            index
                          ) {
                            return _c("tr", { key: index }, [
                              _c("td", { staticClass: "text-center" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "box-selected-product-image w-40"
                                  },
                                  [
                                    _c("img", {
                                      staticClass:
                                        "selected-product-image img-responsive",
                                      attrs: {
                                        src: selectedProduct.image,
                                        alt: ""
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    class:
                                      "box-delivery-judgment-status " +
                                      _vm.getJudgmentStatusClass(
                                        selectedProduct.status_str
                                      )
                                  },
                                  [_vm._v(_vm._s(selectedProduct.status_str))]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("div", { staticClass: "m-b-xs" }, [
                                  _vm._v(_vm._s(selectedProduct.itemName))
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c("b", [_vm._v("ASIN：")]),
                                  _vm._v(_vm._s(selectedProduct.asin) + " / "),
                                  _c("b", [_vm._v("SKU：")]),
                                  _vm._v(_vm._s(selectedProduct.sku) + " ")
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c("b", [_vm._v("商品ID：")]),
                                  _vm._v(
                                    _vm._s(selectedProduct.itemId) + " / "
                                  ),
                                  _c("b", [_vm._v("商品ラベル：")]),
                                  _vm._v(_vm._s(selectedProduct.goodsLabel))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("td", { attrs: { colspan: "3" } }, [
                                _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "text-right w-220 no-borders no-padding"
                                    },
                                    [
                                      _c("span", {}, [
                                        _vm._v(_vm._s(selectedProduct.sizeName))
                                      ]),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("span", {}, [
                                        _vm._v(
                                          _vm._s(selectedProduct.storageSize)
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "text-right w-100 no-borders no-padding"
                                    },
                                    [
                                      _c("span", {}, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatNumber(
                                              selectedProduct.scQuantity
                                            )
                                          ) + " 個"
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "no-borders" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: selectedProduct.quantity,
                                          expression: "selectedProduct.quantity"
                                        }
                                      ],
                                      staticClass:
                                        "form-control expected-delivery-number text-right mr-l-10",
                                      class:
                                        parseInt(selectedProduct.quantity) &&
                                        parseInt(selectedProduct.quantity) <=
                                          parseInt(selectedProduct.scQuantity)
                                          ? ""
                                          : "bg-no-input",
                                      attrs: { type: "text" },
                                      domProps: {
                                        value: selectedProduct.quantity
                                      },
                                      on: {
                                        input: [
                                          function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              selectedProduct,
                                              "quantity",
                                              $event.target.value
                                            )
                                          },
                                          function($event) {
                                            selectedProduct.quantity = _vm.handleInputQuantity(
                                              selectedProduct.quantity
                                            )
                                          }
                                        ],
                                        blur: _vm.updateStorageProducts
                                      }
                                    })
                                  ])
                                ]),
                                _vm._v(" "),
                                _vm.validateErrors.quantity[
                                  selectedProduct.itemId
                                ] &&
                                _vm.validateErrors.quantity[
                                  selectedProduct.itemId
                                ].length
                                  ? _c(
                                      "div",
                                      { staticClass: "text-red text-right" },
                                      [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.validateErrors.quantity[
                                                selectedProduct.itemId
                                              ][0]
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-delete-selected-product check-maintenance",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        _vm.deleteSelectedProduct(
                                          selectedProduct
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("削除")]
                                )
                              ])
                            ])
                          }),
                          0
                        )
                      ])
                    ])
                  : _c("div", { staticClass: "empty-products text-center" }, [
                      _vm._m(5)
                    ])
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mr-t-20", staticStyle: { "min-width": "1500px" } },
          [
            _c("div", { staticClass: "flexbox gap-15" }, [
              _c("svg", { attrs: { width: "50", height: "50" } }, [
                _c("circle", {
                  attrs: {
                    cx: "25",
                    cy: "25",
                    r: "20",
                    stroke: "#008cc6",
                    "stroke-width": "3",
                    fill: "#008cc6"
                  }
                }),
                _vm._v(" "),
                _c(
                  "text",
                  {
                    attrs: {
                      x: "50%",
                      y: "50%",
                      "text-anchor": "middle",
                      "dominant-baseline": "central",
                      "font-size": "20",
                      fill: "#fff"
                    }
                  },
                  [_vm._v("4")]
                )
              ]),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "font-bold text-size-16 text-primary" },
                [_vm._v("配送方法入力")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "mr-t-10 bg-white mr-l-30",
                staticStyle: {
                  border: "1px solid #ccc",
                  "margin-left": "30px",
                  padding: "10px",
                  "min-height": "300px"
                }
              },
              [
                _c("p", [_vm._v("ご希望の配送方法を選択してください。")]),
                _vm._v(" "),
                _c("div", { staticClass: "shipping-method" }, [
                  _vm._m(6),
                  _vm._v(" "),
                  _c("div", [
                    _c("span", { staticClass: "text-red" }, [
                      _vm._v(
                        "配送方法を選択する際は、以下の点にご注意ください。"
                      )
                    ]),
                    _vm._v(" "),
                    _vm._m(7),
                    _vm._v(" "),
                    _c("div", { staticClass: "shipping-method--options" }, [
                      _vm.validateErrors.transporterCode
                        ? _c("div", { staticClass: "text-red" }, [
                            _c("b", [
                              _vm._v(_vm._s(_vm.validateErrors.transporterCode))
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "radio-group" }, [
                        _c(
                          "div",
                          {
                            staticClass: "radio-option",
                            class: { selected: _vm.transporterCode == "1004" }
                          },
                          [
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.transporterCode,
                                    expression: "transporterCode"
                                  }
                                ],
                                attrs: { type: "radio", value: "1004" },
                                domProps: {
                                  checked: _vm._q(_vm.transporterCode, "1004")
                                },
                                on: {
                                  change: function($event) {
                                    _vm.transporterCode = "1004"
                                  }
                                }
                              }),
                              _vm._v("  ネコポス\n                  ")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "radio-option",
                            class: { selected: _vm.transporterCode == "1009" }
                          },
                          [
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.transporterCode,
                                    expression: "transporterCode"
                                  }
                                ],
                                attrs: { type: "radio", value: "1009" },
                                domProps: {
                                  checked: _vm._q(_vm.transporterCode, "1009")
                                },
                                on: {
                                  change: function($event) {
                                    _vm.transporterCode = "1009"
                                  }
                                }
                              }),
                              _vm._v(
                                "  宅配便（60サイズ以上）PE袋\n                  "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "radio-option",
                            class: { selected: _vm.transporterCode == "1001" }
                          },
                          [
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.transporterCode,
                                    expression: "transporterCode"
                                  }
                                ],
                                attrs: { type: "radio", value: "1001" },
                                domProps: {
                                  checked: _vm._q(_vm.transporterCode, "1001")
                                },
                                on: {
                                  change: function($event) {
                                    _vm.transporterCode = "1001"
                                  }
                                }
                              }),
                              _vm._v(
                                "  宅配便（60サイズ以上）ダンボール\n                  "
                              )
                            ])
                          ]
                        )
                      ])
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _vm.selectedProducts.length
              ? _c("div", { staticClass: "text-center m-b-md m-t-md" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-primary custom-btn check-maintenance",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.submitValidate($event)
                        }
                      }
                    },
                    [
                      _vm._v("\n            出荷依頼\n            "),
                      _c("i", {
                        staticClass: "fa fa-check fa-lg mr-l-5",
                        attrs: { "aria-hidden": "true" }
                      })
                    ]
                  )
                ])
              : _vm._e()
          ]
        )
      ]),
      _vm._v(" "),
      _vm.openProductAddModal
        ? _c("shipping-multi-channel-product-add", {
            ref: "shippingMultiProductAddModal",
            attrs: {
              iconUrls: _vm.iconUrls,
              selectedProducts: _vm.storageSelectedProducts
            },
            on: {
              close: _vm.closeModalProductAdd,
              handleSelectedProduct: _vm.handleSelectedProduct,
              handleSelectedProducts: _vm.handleSelectedProducts
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.openAlertValidateFailsModal
        ? _c("modal-alert", {
            attrs: { message: _vm.alertValidateFailsMessage, customHide: true },
            on: { close: _vm.closeModalAlertValidateFails }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.openProductsAddConfirmModal
        ? _c("modal-confirm", {
            attrs: { message: _vm.productsAddConfirmMessage },
            on: {
              confirm: _vm.registerShippingMultichannel,
              close: _vm.closeModalConfirmProductsAdd
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.openAlertProductsAddedModal
        ? _c("modal-alert", {
            attrs: {
              message: _vm.alertProductsAddedMessage,
              customHide: true,
              modalWidth: 550
            },
            on: { close: _vm.closeModalAlertProductsAdded }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.openShippingMultichannelInfoModal
        ? _c("shipping-multichannel-info-modal", {
            ref: "shippingMultichannelInfoModal",
            on: {
              close: _vm.closeModalShippingMultichannelInfo,
              openModalRegisterShippingInfo: _vm.openModalRegisterShippingInfo,
              setDefaultInfoSuccess: _vm.registerShippingInfo
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.openRegisterShippingInfoModal
        ? _c("register-shipping-info-modal", {
            ref: "registerShippingInfoModal",
            on: {
              close: _vm.closeModalRegisterShippingInfo,
              registerShippingInfo: _vm.registerShippingInfo
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.openRegisterDeliveryInfoModal
        ? _c("register-delivery-info-modal", {
            ref: "registerDeliveryInfoModal",
            attrs: { deliveryInfo: _vm.deliveryInfo },
            on: {
              close: _vm.closeModalRegisterDeliveryInfo,
              updatedDeliveryInfo: _vm.updatedDeliveryInfo
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowUploadModal
        ? _c("upload-csv-modal", {
            attrs: {
              header: _vm.uploadCsvHeader,
              uploadUrl: "Warehouse/sc/shipping/multichannel/upload",
              needProductId: true,
              note:
                "※配送方法は「ネコポス」「宅配便PE」「宅配便ダンボール」のいずれかを入力してください。",
              settingProductIdOptions: _vm.settingProductIdOptions
            },
            on: {
              handleDownloadTemplate: _vm.handleDownloadTemplate,
              handleUploadSuccess: _vm.handleUploadSuccess,
              close: _vm.closeUploadModal
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowBulkShipmentReview
        ? _c("bulk-shipment-review", {
            attrs: { shippings: _vm.uploadShippings },
            on: {
              close: _vm.closeBulkShipmentReview,
              openModalUpload: _vm.openModalUpload,
              updateShippings: _vm.updateShippings,
              deleteShippings: _vm.deleteShippings
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.openModalAlert
        ? _c("modal-alert", {
            attrs: {
              message: _vm.alertMessage,
              customHide: true,
              modalWidth: 550
            },
            on: { close: _vm.closeModalAlert }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "mr-t-15 text-warning bg-warning font-bold",
        staticStyle: { "margin-left": "30px", width: "850px" }
      },
      [
        _c("span", { staticStyle: { padding: "10px" } }, [
          _vm._v(
            "14:30までの登録は当日出荷、14:30以降の登録は翌日出荷となります。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-2 col-lg-1 w-150" }, [
      _c("div", { staticClass: "delivery-name" }, [
        _c("strong", [_vm._v("出荷名")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-2 col-lg-1 w-150" }, [
      _c("div", { staticClass: "delivery-name" }, [
        _c("strong", [_vm._v("依頼番号(任意)")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-2 col-lg-1 w-150" }, [
      _c("div", { staticClass: "m-b-sm" }, [
        _c("strong", [_vm._v("発送元情報")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "text-center w-150" }, [
          _vm._v("出荷する商品")
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { "min-width": "500px" } }),
        _vm._v(" "),
        _c("th", { staticClass: "text-right w-200" }, [_vm._v("保管サイズ")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right w-100" }, [_vm._v("在庫数")]),
        _vm._v(" "),
        _c("th", { staticClass: "w-120" }, [_vm._v("出荷予定数")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center w-100" }, [_vm._v("操作")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "m-b-xl text-center" }, [
      _c("strong", [_vm._v("商品選択より、出荷する商品を選択してください。")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "mr-r-10", staticStyle: { color: "#ffae2c" } },
      [
        _c("i", {
          staticClass: "fa fa-exclamation-triangle text-size-20",
          attrs: { "aria-hidden": "true" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "note" }, [
      _vm._v(
        "\n              指定した配送方法での梱包が難しく商品がPE袋や段ボールに収まらない場合は、以下のような対応をとらせていただきます。\n              "
      ),
      _c("ul", [
        _c("li", [_vm._v("出荷指示を自動的にキャンセル。")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "適切な配送方法へ自動的に切り替え。※配送を切り替えた場合、配送切替費用がかかります。"
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "text--underline",
          attrs: {
            href:
              "https://www.canva.com/design/DAGjizk6zLU/-UQBwTyh_GZMp_73hfrbMA/view",
            target: "_blank"
          }
        },
        [_vm._v("> 詳しくはこちら")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6fea14b5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fea14b5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/warehouseSc/MultiChannelShipping.vue
// module id = null
// module chunks = 